import {
  DRAGGING,
  RUNNING_STATE,
  SAVE_PROPS,
  DRAGGABLE,
  CLONE_MOUNTED,
  PAUSED_ON_FULLSCREEN,
  SET_DEFAULT_MESSAGE,
  CHANGE_MESSAGE,
  CLOSE_MESSAGE,
} from "../actions/carouselActions/types";

const initialState = {
  isTap: true,
  running: true,
  scrolled: false,
  draggable: true,
  pausedOnFullscreen: false,
  canPlayVideos: false,
  message: {
    default: {},
    slide: {},
    closed: true,
    seenMessages: new Set(),
    userOpened: false,
  },
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case DRAGGING:
      return {
        ...state,
        isTap: action.payload,
      };
    case RUNNING_STATE:
      return {
        ...state,
        running: action.payload.running,
        scrolled: typeof action.payload.scrolled === "boolean" ? action.payload.scrolled : state.scrolled,
      };
    case SAVE_PROPS:
      return {
        ...state,
        ...action.payload,
      };
    case DRAGGABLE:
      return {
        ...state,
        draggable: action.payload,
      };
    case CLONE_MOUNTED: {
      const newState = state;
      delete newState[action.payload];
      return newState;
    }
    case PAUSED_ON_FULLSCREEN:
      return {
        ...state,
        pausedOnFullscreen: action.payload,
      };
    case SET_DEFAULT_MESSAGE:
      state.message.seenMessages.add(action.defaultMessage.content);
      return {
        ...state,
        message: {
          ...state.message,
          default: action.defaultMessage,
        },
      };
    case CHANGE_MESSAGE:
      state.message.seenMessages.add(action.slideMessage.content);
      return {
        ...state,
        message: {
          ...state.message,
          slide: action.slideMessage,
        },
      };
    case CLOSE_MESSAGE:
      return {
        ...state,
        message: {
          ...state.message,
          closed: action.closed,
          userOpened: action.userOpened,
        },
      };
    default:
      return state;
  }
};

export default reducer;
